module.exports = __webpack_public_path__ + "static/img/product-poster-6.5dfb72aa.png";